<template>
  <v-card>
    <v-card-text>
      <p>Search for the courses you would like to take below and select them out of the list to add them to your courses. This schedule is a work-in-progress. We will do our best to stick with this requested schedule, but due to various issues that may arise we cannot guarantee the requested schedule.</p>
      <v-list>
          <v-list-item>
              <v-list-item-avatar>
                  <v-icon color="warning">fas fa-stop-circle</v-icon>
              </v-list-item-avatar>
              <v-list-item-content>
                  <v-list-item-title>Course is full</v-list-item-title>
                  <v-list-item-subtitle style="overflow:visible;white-space:normal">You may select the course but you will be placed on the waiting list.</v-list-item-subtitle>
              </v-list-item-content>
          </v-list-item>
          <v-list-item>
              <v-list-item-avatar>
                  <v-icon color="info">fas fa-exclamation-circle</v-icon>
              </v-list-item-avatar>
              <v-list-item-content>
                  <v-list-item-title>Course is almost full</v-list-item-title>
                  <v-list-item-subtitle style="overflow:visible;white-space:normal">There is a high chance that you might be placed on the waiting list or may be put into a different section or a different course.</v-list-item-subtitle>
              </v-list-item-content>
          </v-list-item>
          <v-list-item>
              <v-list-item-avatar>
                  <v-icon color="error">fas fa-times</v-icon>
              </v-list-item-avatar>
              <v-list-item-content>
                  <v-list-item-title>Remove Course</v-list-item-title>
                  <v-list-item-subtitle style="overflow:visible;white-space:normal">To remove an added course, click on this icon to the right of that course to remove it. Christian Mind is required for all new students, so that class cannot be removed.</v-list-item-subtitle>
              </v-list-item-content>
          </v-list-item>
      </v-list>
      <p>Courses sometimes get full between the time that you submit and the time we are able to process it. If a course is full before your registration is processed, you might not get into that course. If the course is required for your major and is marked as full or almost full, please add it to the schedule anyway. Our advisers will try their best to get you into the courses you choose, but some changes may be necessary.</p>
      <p v-if="provisional">You were admitted on a provisional status. You must register for GE131 College Life and can only register for up to 15 credit hours, including Christian Mind and College Life.</p>
      <p v-else-if="macScholar">As a Maclellan scholar, you are required to take MSP143. This has been added to the selected course list for you.</p>
    </v-card-text>
    <v-card-actions>
      <v-btn color="primary" @click="next()">Continue</v-btn>
      <v-btn @click="$emit('back')">Back</v-btn>
    </v-card-actions>
  </v-card>
</template>
<script>
import { ref } from '@vue/composition-api'
export default {
  setup (props, { emit }) {
    const provisional = ref(false)
    const macScholar = ref(false)

    function next () {
      emit('next')
    }

    return {
      provisional,
      macScholar,
      next
    }
  }
}
</script>
